import React from 'react';

import { flagStyles } from '../settings';

const SvgKH = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-2760px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgKH;
